import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "center",

    width: "calc(100% - 30px)",

    margin: "4px 15px",
    padding: "12px 16px",

    borderRadius: "12px",

    cursor: "pointer",

    color: "#aaa9bb",

    transition: "all 0.3s ease",

    "&:hover": {
      color: "#fff",
      backgroundColor: "rgba(255, 255, 255, 0.06)",
      transform: "translateX(5px)",
    },

    "&.active": {
      color: "#fff",
      background:
        "linear-gradient(90deg, rgba(255, 0, 85, 0.18), rgba(255, 0, 85, 0.03))",

      borderLeft: "3px solid #ff0055",
    },
  },

  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    width: 30,

    color: "inherit",

    "& svg": {
      fontSize: 22,
    },
  },

  heading: {
    margin: 0,
    padding: 0,

    fontSize: 14,
    fontWeight: 600,

    color: "inherit",

    letterSpacing: "0.2px",
  },
});

export default function Sidebaritem(props) {
  const classes = useStyles();

  const handleClick = () => {
    const element = document.getElementById(props.id);

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }

    if (props.onClick) {
      props.onClick(props.id);
    }
  };

  return (
    <div
      onClick={handleClick}
      className={`${classes.root} ${
        props.active ? "active" : ""
      }`}
    >
      <div className={classes.icon}>
        {props.icon}
      </div>

      <h3 className={classes.heading}>
        {props.h3}
      </h3>
    </div>
  );
}